/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding initialization code.
 * Use "quasar new plugin <name>" and add it there.
 * One plugin per concern. Then reference the file(s) in quasar.conf.js > plugins:
 * plugins: ['file', ...] // do not add ".js" extension to it.
 **/

import 'quasar-framework/dist/quasar.ie.polyfills.js'






import 'quasar-app-styl'


import 'src/css/app.styl'


import Vue from 'vue'
import createApp from './app.js'


import 'app/src-pwa/register-service-worker.js'



import pAuthDirectives from 'src/plugins/authDirectives'

import pAxios from 'src/plugins/axios'

import pI18n from 'src/plugins/i18n'

import pLocalSettings from 'src/plugins/localSettings'

import pMultiBrowserTabs from 'src/plugins/multiBrowserTabs'

import pRefreshToken from 'src/plugins/refreshToken'

import pRouterAuth from 'src/plugins/routerAuth'

import pSentry from 'src/plugins/sentry'

import pTeamValidator from 'src/plugins/teamValidator'

import pVeeValidate from 'src/plugins/veeValidate'

import pVueClipboard from 'src/plugins/vueClipboard'

import pVueShortkey from 'src/plugins/vueShortkey'

import pVuexRouterSync from 'src/plugins/vuexRouterSync'

import pHydrateStore from 'src/plugins/hydrateStore'

import pMatomo from 'src/plugins/matomo'





import FastClick from 'fastclick'










const { app, store, router } = createApp()



  // Needed only for iOS PWAs
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && window.navigator.standalone) {

  document.addEventListener('DOMContentLoaded', () => {
    FastClick.attach(document.body)
  }, false)

}




;[pAuthDirectives,pAxios,pI18n,pLocalSettings,pMultiBrowserTabs,pRefreshToken,pRouterAuth,pSentry,pTeamValidator,pVeeValidate,pVueClipboard,pVueShortkey,pVuexRouterSync,pHydrateStore,pMatomo].forEach(plugin => {
  plugin({
    app,
    router,
    store,
    Vue,
    ssrContext: null
  })
})









new Vue(app)






